import Vue from 'vue'
import axios from 'axios'
import router from '@/router'

let url = process.env.VUE_APP_BASE_URL;
axios.defaults.baseURL = url + '/api'
Vue.prototype.$baseURL = url

axios.interceptors.response.use((response) => {
  return response
}, (error) => {
  if (error.response.status === 401) {
    if (error.response.data.message == "Unauthenticated.") {
      router
        .push({name: "HomePage"})
        .catch(err => {
          console.log(err)
        })
    }
  }

  return Promise.reject(error)
})
